/** Working brand for the public testnet. Change the name here (and the <title> in index.html, and the logo width in wallet/privy.tsx) to rebrand. */
export const BRAND = {
  name: 'RWALend',
  marketName: 'RWALend Market',
  faucetUrl: 'https://faucet.testnet.chain.robinhood.com/',
  /** Attribution required by the upstream licence: keep it, and never present this product as Aave or Robinhood. */
  upstream: 'aave-v3-origin v3.7.0 (BUSL-1.1)',
} as const;
